export const LIST_RADIO_GENDER = [
  { title: 'userProfile.MR', value: 0 },
  { title: 'userProfile.MS', value: 1 },
]

export const KEYS_FIELD_LIST = {
  FIRST_NAME: 'firstName',
  MIDDLE_NAME: 'middleName',
  LAST_NAME: 'lastName',
  EMAIL: 'userName',
  JOB_TITLE: 'jobTitle',
  PHONE: 'phone',
  ACCOUNT_TYPE: 'accountType',
  COMPANY_NAME: 'companyName',
  COUNTRY: 'companyCountry',
  TAX_CODE: 'companyTaxCode',
  INDUSTRY: 'companyIndustry',
  WEBSITE: 'companyWebsite',
  CONTACT_EMAIL: 'companyEmail',
  COMPANY_PHONE: 'companyPhone',
  ADDRESS: 'companyAddress',
  GENDER: 'gender',
}

export const POPUP_FIELDS_KEYS = {
  EMAIL: 'CompanyEmail',
  COMPANY_NAME: 'CompanyName',
  COUNTRY: 'CompanyLocationId',
  TAX_CODE: 'CompanyTaxCode',
  INDUSTRY: 'CompanyVSICId',
  NONE: 'none',
}

export const POPUP_FIELDS_LIST = [
  {
    title: 'userProfile.EMAIL',
    key: POPUP_FIELDS_KEYS.EMAIL,
    isRequired: true,
  },
  {
    title: 'userProfile.COMPANY_NAME',
    key: POPUP_FIELDS_KEYS.COMPANY_NAME,
    isRequired: true,
  },
  {
    title: 'userProfile.COUNTRY',
    key: POPUP_FIELDS_KEYS.COUNTRY,
    isRequired: true,
  },
  {
    title: 'userProfile.TAX_CODE',
    key: POPUP_FIELDS_KEYS.TAX_CODE,
    isRequired: true,
  },
  {
    title: 'userProfile.INDUSTRY',
    key: POPUP_FIELDS_KEYS.INDUSTRY,
    isRequired: true,
  },
]

const {
  FIRST_NAME,
  MIDDLE_NAME,
  LAST_NAME,
  EMAIL,
  JOB_TITLE,
  ACCOUNT_TYPE,
  COMPANY_NAME,
  TAX_CODE,
  INDUSTRY,
  COUNTRY,
  WEBSITE,
  CONTACT_EMAIL,
  PHONE,
  ADDRESS,
  COMPANY_PHONE,
} = KEYS_FIELD_LIST

export const LEFT_FIELDS = [
  { title: 'userProfile.FIRST_NAME', key: FIRST_NAME, isRequired: true },
  { title: 'userProfile.MIDDLE_NAME', key: MIDDLE_NAME },
  { title: 'userProfile.LAST_NAME', key: LAST_NAME, isRequired: true },
  {
    title: 'userProfile.EMAIL',
    isDisable: true,
    key: EMAIL,
  },
  { title: 'userProfile.JOB_TITLE', key: JOB_TITLE, isRequired: true },
  { title: 'userProfile.ACCOUNT_TYPE', key: ACCOUNT_TYPE },
]

export const RIGHT_FIELDS = [
  {
    title: 'userProfile.COMPANY_NAME',
    isDisable: true,
    key: COMPANY_NAME,
  },
  {
    title: 'userProfile.COUNTRY',
    isDisable: true,
    key: COUNTRY,
  },
  {
    title: 'userProfile.TAX_CODE',
    isDisable: true,
    key: TAX_CODE,
  },
  {
    title: 'userProfile.INDUSTRY',
    isDisable: true,
    key: INDUSTRY,
  },
  { title: 'userProfile.WEBSITE', key: WEBSITE },
  { title: 'userProfile.CONTACT_EMAIL', key: CONTACT_EMAIL, isRequired: true },
  { title: 'userProfile.COMPANY_PHONE', key: COMPANY_PHONE },
  { title: 'userProfile.ADDRESS', key: ADDRESS },
]

export const ALL_FIELDS = Object.values(KEYS_FIELD_LIST)
export const IS_VALID_FIELDS = Object.assign(
  {},
  ...Object.keys(KEYS_FIELD_LIST).map((item) => ({ [item]: true })),
)

export const ALL_REQUIRED_FIELDS = [
  ...[...LEFT_FIELDS, ...RIGHT_FIELDS]
    .filter((item) => item.isRequired)
    .map((item) => item.key),
  PHONE,
  COMPANY_PHONE,
]

export const SELECT_FIELD = {
  label: 'userProfile.SELECT_FIELD',
  value: '',
  isI18n: true,
}

export const POPUP_FIELDS = [
  SELECT_FIELD,
  ...POPUP_FIELDS_LIST.map((item) => ({
    label: item.title,
    value: item.key,
    isI18n: true,
  })),
]

export const IS_VALID_POPUP_FIELDS = Object.assign(
  {},
  ...Object.keys(POPUP_FIELDS_LIST).map((item) => ({ [item]: true })),
)

export const FORM_FIELDS = [
  ...[...LEFT_FIELDS, ...RIGHT_FIELDS]
    .filter((item) => !item.isDisable)
    .map((item) => item.key),
  PHONE,
]
